module.exports = __webpack_public_path__ + "static/media/aspects-explanation-IF.602f85b0.svg";